<template>
    <notification-item
        title="Žádost o vstup do týmu"
        :created="data.created"
        :author="data.payload.teamName"
        avatar="/img/myteam/Team-Crest.png"
        :link="{ name: 'teamDetail', params: { id: data.payload.teamId } }"
    >
        <p>Vaše žádost o vstup do týmu <span class="semibold semibold--textgreen"><router-link :to="{ name: 'teamDetail', params: { id: data.payload.teamId } }">{{ data.payload.teamName }}</router-link></span> byla přijata.</p>
        <p>Vítejte v týmu!</p>

        <template v-slot:actions>
            <v-btn
                color="primary" dark
                :to="{ name: 'teamDetail', params: { id: data.payload.teamId } }"
            >
                Zobrazit tým
            </v-btn>
        </template>
    </notification-item>
</template>

<script>
    import NotificationMixin from '../NotificationMixin';

    export default {
        name: 'TeamRequestAccepted',
        mixins: [NotificationMixin],
    }
</script>
